import moment from 'moment'

export default ['$scope', 'calendar', function($scope, Calendar) {
  this.calendarOne = Calendar.create();
  this.calendarTwo = Calendar.create();

  // TODO: Revisit this hack, as it was put in for a reason, but it was also causing an infinite digest loop
  let _range = null;

  // Hack to make range not through null reference exceptions when set to null
  Object.defineProperty(this, 'range', {
    get: function() {
      return _range || (_range = {});
    },

    set: function(val) { _range = val; }
  })

  this.isSelected = date => {
    const range = moment.range(this.range.startDate, this.range.endDate)
    return date && range && range.contains(date);
  };

  this.startDateSelected = date => {
    this.duration(date, this.range.endDate)
    return this.range.startDate = date;
  };

  this.endDateSelected = date => {
    this.duration(this.range.startDate, date)
    return this.range.endDate = date;
  };

  this.duration = (startDate, endDate) => {
    let months = moment(endDate).diff(startDate, 'months')
    const days = moment(endDate).diff(startDate, 'days') + 1

    if (months > 0) {
      if (days - (months * (365/12)) > (365/12/2)) {months += 1}
      this.range.selectedValue = months + 'M';
    } else if (months === 0) {
      this.range.selectedValue = days + 'd';
    }
    this.range = _.clone(this.range);
  };

  this.minEndDate = () => {
    return moment.max(moment(this.startDate), moment(this.range.startDate))
      .format('YYYY-MM-DD');
  }

  this.maxStartDate = () => {
    return moment.min(moment(this.endDate), moment(this.range.endDate))
      .format('YYYY-MM-DD');
  }

  $scope.$watch('ctrl.active', () => {
    if (this.active) {
      this.calendarOneDate = this.range.startDate;
      return this.calendarTwoDate = this.range.endDate;
    }
  });

  return this;
}
];
